'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertMessage = require('./AlertMessage');

var _AlertMessage2 = _interopRequireDefault(_AlertMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AlertMessage2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-alert/dist/alert/index.js
// module id = 989
// module chunks = 0